<div class="custom-dropdown h-100">
  <input
    required
    class="dropdown-toggle form-control"
    type="text"
    (click)="toggleDropDown($event)"
    (focus)="isDropDownFocused = true"
    (blur)="isDropdownOpen = false; isDropDownFocused = false"
    onchange="return false;"
    [ngModel]="selectedCountryName"
    onkeydown="return false;"
    readonly
  />
  <!--
  lock this input with "readonly" regarding typing / copying / inserting to prevent tools to auto fill it.
  Auto filling results in malformed / missing data since the events and mapping aren't called.
  -->

  @if (isDropdownOpen && isDropDownFocused) {
    <div class="dropdown-menu">
      @for (country of countryList; track country) {
        <div [id]="country.dialingCode" class="dropdown-item" [class.selected]="selectedCountry?.dialingCode != undefined && selectedCountry?.dialingCode == country.dialingCode" (click)="selectItem(country)" (mousedown)="$event.preventDefault()">
          <img [src]="'./assets/images/flags/' + country.twoLetterIsoRegionName?.toLowerCase() + '.svg'" [alt]="country.country" />
          <span>{{ country.country }}</span>
        </div>
      }
    </div>
  }
</div>
